<template>
  <div class="header bg-color-write border-bottom sticky-custom">
    <header class="d-flex line-bottom">
      <div class="d-flex align-items-center">
        <LogoComponent
          width="38"
          height="38"
          class="mr-4 image-logo-nav"
          color="blue"
          @onClick="onClickLogo"
        />
        <nav class="navbar navbar-expand-lg navbar-light md__nav_main">
          <NavbarResponsiveComponent />
          <div class="collapse navbar-collapse" id="navbarNav">
            <NavbarItemsComponent classNames="small" />
          </div>
        </nav>
      </div>

      <section class="px-3 px-lg-4 md__nav_main-items-right pt-1">
        <div class="d-flex justify-content-between ">
          <div class="d-flex align-items-center">
            <button
              class="copilot-trigger-btn"
              @click="$store.dispatch('copilot/open')"
              title="Mydessk IA"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z"
                />
              </svg>
              <span class="copilot-pulse-dot"></span>
            </button>
            <CreditsIndicator />
            <NotifBell />
            <div class="business-selected p-1 business-main">
              <div
                class="image-logo-header rounded-circle"
                v-if="
                  getUser &&
                    getUser.user_business &&
                    getUser.user_business.business_logo &&
                    !businessLogoError
                "
              >
                <img
                  :src="getUser.user_business.business_logo"
                  alt=""
                  @error="businessLogoError = true"
                />
              </div>
              <TextAvatarComponent
                :text="getUser.user_business.business_name"
                class="p-0"
                style="width: 30px !important; height: 30px !important;"
                v-else
              />
              <h5 class="font-medium mx-2 mb-0">
                {{ getUser.user_business.business_name }}
              </h5>
            </div>
            <div id="profile-image" class="mx-3">
              <img
                :src="getUser.image"
                :alt="getUser.name"
                :title="getUser.name"
                v-if="getUser.image && !profileImageError"
                @error="profileImageError = true"
              />
              <span class="user-initials" v-else>{{ userInitials }}</span>
            </div>
            <span id="popover-profile">
              <IconMoreOptionComponent size="small" theme="blue" />
            </span>

            <b-popover
              target="popover-profile"
              triggers="hover"
              placement="bottomleft"
              custom-class="ucp-popover"
            >
              <template v-slot:title>
                <div class="ucp-header">
                  <div class="ucp-header-info">
                    <span class="ucp-header-name">{{ getUser.name }}</span>
                    <span class="ucp-header-email">{{ getUser.email }}</span>
                  </div>
                  <button class="ucp-header-btn" @click.prevent="profile">
                    <i class="el-icon-user"></i> Mi cuenta
                  </button>
                </div>
              </template>
              <user-content-popover :user="this.getUser"></user-content-popover>
            </b-popover>
          </div>
        </div>
      </section>
    </header>
    <TransitionFadeComponent>
      <SubMenuComponent />
    </TransitionFadeComponent>
  </div>
</template>

<script>
import SubMenuComponent from "@/components/SubMenu/SubMenu";
import LogoComponent from "@/components/Logo/Logo";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import TransitionFadeComponent from "@/components/Transitions/Fade";
import NavbarResponsiveComponent from "./components/NavbarResponsive";
import NavbarItemsComponent from "./components/NavbarItems";
import UserContentPopover from "./components/UserContentPopover";
import { icoBell, icoOption, icoUserLine } from "@/services/resources";
import TextAvatarComponent from "../../modules/dashboard/sales/components/TextAvatar";
import NotifBell from "@/components/NotifBell";
import CreditsIndicator from "./components/CreditsIndicator";

export default {
  name: "DashboardHeaderComponent",
  data: () => ({
    icoBell,
    icoOption,
    icoUserLine,
    businessLogoError: false,
    profileImageError: false
  }),
  methods: {
    onClickLogo() {
      this.$router.push({ name: "dashboard" });
    },
    profile() {
      this.$router.push({ name: "profile" });
    },
    onToggleSubMenu(property) {
      this[property] = !this[property];
      this.toggleSubMenu = this[property];
    }
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    userInitials() {
      const name = this.getUser.name ? this.getUser.name[0] : "";
      const lastName = this.getUser.last_name ? this.getUser.last_name[0] : "";
      return (name + lastName).toUpperCase();
    }
  },
  components: {
    SubMenuComponent,
    LogoComponent,
    IconMoreOptionComponent,
    TransitionFadeComponent,
    NavbarResponsiveComponent,
    NavbarItemsComponent,
    UserContentPopover,
    TextAvatarComponent,
    NotifBell,
    CreditsIndicator
  }
};
</script>

<style scoped lang="scss">
header {
  position: relative;

  .md__nav_main-items-right {
    position: absolute;
    right: 0;
    top: 0;
  }

  .notificaciones {
    span {
      border: #fff 2px solid;
      border-radius: 50%;
      color: #fff;
      background: #01ea75;
      padding: 1px 6px;
      font-size: 10px;
      position: absolute;
      top: -8px;
      left: 18px;
    }
  }

  .bell-alert {
    color: #e3e3e3;
    font-size: 26px;
  }

  #profile-image {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 3px solid #3fdbbf;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #31355c;
    cursor: default;

    img {
      transition: all 0.2s ease-in;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;

      &.not-image-profile {
        width: 30px;
        height: 30px;
        border-radius: 0%;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .user-initials {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      text-transform: uppercase;
      line-height: 1;
      letter-spacing: 0.5px;
    }
  }
}

.btn-a {
  display: flex;
  align-items: center;
}

#btn-profile-popover {
  display: flex;
  justify-content: center;
  min-height: 40px !important;
}

.image-logo-header {
  padding: 0;
  width: 30px;
  height: 30px;
  min-width: 30px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }
}

.business-main {
  border-radius: 8px;
  background: #fff;
  color: black;
  max-width: 220px;
}

.business-selected {
  display: flex;
  align-items: center;
  border: 1px solid #e4eaf6;
  overflow: hidden;
  padding-left: 10px !important;

  h5 {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
}

// Logo styling
.image-logo-nav {
  width: 38px !important;
  height: 38px !important;
  border-radius: 10px;
  object-fit: contain;
  padding: 4px;
  margin-left: 8px;
}

// Sticky header siempre
.sticky-custom {
  position: sticky;
  top: 0;
  z-index: 1020;
}

// Popover header
.ucp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
}
.ucp-header-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ucp-header-name {
  font-size: 14px;
  font-weight: 700;
  color: #31355c;
}
.ucp-header-email {
  font-size: 12px;
  color: #909399;
}
.ucp-header-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  border: 1px solid #e4eaf6;
  border-radius: 8px;
  background: #fff;
  color: #31355c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    background: #f7f8f9;
    border-color: #31355c;
  }
}

// Copilot trigger button
.copilot-trigger-btn {
  position: relative;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: #2d2b55;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.15s;
  margin-right: 10px;
  &:hover {
    background: #3ecfb4;
  }
}
.copilot-pulse-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3ecfb4;
  border: 1.5px solid #2d2b55;
}

// Mobile: header compacto
@media (max-width: 768px) {
  .business-main {
    max-width: 180px;
    padding: 4px 8px !important;
  }
  .business-selected h5 {
    font-size: 12px;
    max-width: 100px;
  }
  .image-logo-header {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px;
  }
  #profile-image {
    width: 38px !important;
    height: 38px !important;
    border-width: 2px !important;
  }
  .copilot-trigger-btn {
    width: 30px;
    height: 30px;
    margin-right: 6px;
    svg {
      width: 14px;
      height: 14px;
    }
  }
}

// iPhone SE / small phones
@media (max-width: 420px) {
  .business-main {
    max-width: 150px;
    padding: 3px 6px !important;
  }
  .business-selected h5 {
    font-size: 11px;
    max-width: 70px;
  }
  #profile-image {
    width: 34px !important;
    height: 34px !important;
    margin-left: 6px !important;
    margin-right: 6px !important;
  }
  .copilot-trigger-btn {
    width: 28px;
    height: 28px;
    margin-right: 4px;
  }
  header .md__nav_main-items-right {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}
</style>

<style lang="scss">
// El popover del perfil vive fuera del componente (portal), por eso este
// bloque no es scoped. En ventanas bajas el menú no debe salirse de la
// pantalla: al ser por hover, desplazar la página lo cierra y las últimas
// opciones quedarían inalcanzables. Se limita al alto visible y solo hace
// scroll cuando de verdad no cabe.
.ucp-popover .popover-body {
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  overscroll-behavior: contain;
}
@media (max-height: 640px) {
  .ucp-popover .popover-body .ucp-business-card {
    padding: 8px 12px;
  }
  .ucp-popover .popover-body .ucp-menu {
    padding: 4px 6px;
  }
  .ucp-popover .popover-body .ucp-menu-item {
    padding: 7px 14px;
  }
}
</style>
